import { notification } from "antd";
import { fetchS3FileUrl } from "@shared/api";
import { NOTIFICATION_MESSAGES } from "./notification-messages";

export const downloadFile = async (
  fileId: string,
  setLoading: (fileId: string, loading: boolean) => void,
) => {
  setLoading(fileId, true);
  try {
    const fileUrl = await fetchS3FileUrl(fileId);

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch {
    notification.error({
      message: NOTIFICATION_MESSAGES.DOWNLOAD_ERROR,
      description: NOTIFICATION_MESSAGES.DOWNLOAD_FILE_ERROR_DESC,
    });
  } finally {
    setLoading(fileId, false);
  }
};
